
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/turmeric",
      function () {
        return require("private-next-pages/turmeric/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/turmeric"])
      });
    }
  